import { TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { NbMenuModule } from '@nebular/theme';
import { OktaRestriction } from 'src/app/core/services/okta-restrictions.service';
import { ENVIRONMENTS } from 'src/app/shared/constants/general-constants';
import { ENVIRONMENT } from 'src/environments/environment';
import { MENU_ITEMS } from './pages-menu';

@Component({
  selector: 'app-pages',
  styleUrls: ['pages.component.scss'],
  template: ` <nb-menu [items]="menu" autoCollapse="true"></nb-menu> `,
  imports: [NbMenuModule]
})
export class PagesComponent {
  public menu;

  constructor(private restrictionService: OktaRestriction) {
    this.menu = MENU_ITEMS;

    if (ENVIRONMENT.isProduction) {
      const index = this.menu.map((i) => i.title).indexOf($localize`QA Tools`);
      this.menu[index].children = this.menu[index].children.filter(
        (child) => ![$localize`Clean Score`, $localize`Cleaning Time Estimates`].includes(child.title)
      );
    }

    if (ENVIRONMENT.name === ENVIRONMENTS.TKSTAGE || ENVIRONMENT.name === ENVIRONMENTS.TKPROD) {
      this.menu = this.menu.filter((item) => ![$localize`DRBs`, $localize`Robot Family Metadata`].includes(item.title));
    }

    if (!this.restrictionService.qa_permission) {
      this.menu = this.menu.filter((item) => item.title !== $localize`QA Tools`);
    }

    if (this.restrictionService.drb_user_permission) {
      this.addDRBMenu();
    }
  }

  public addDRBMenu() {
    const index = this.menu.map((i) => i.title).indexOf($localize`DRBs`);
    if (index !== -1) {
      ENVIRONMENT.bundleNames.forEach((bundle_name) => {
        const title = new TitleCasePipe().transform(bundle_name.replace('_', ' '));
        const child = {
          title,
          link: '/drb/' + bundle_name,
          pathMatch: 'full',
          data: { name: bundle_name },
          children: [
            {
              title: $localize`View`,
              link: '/drb/' + bundle_name + '/view',
              pathMatch: 'full'
            }
          ]
        };
        if (this.restrictionService.drb_manager_permission) {
          if (!ENVIRONMENT.isProduction) {
            child.children.push({
              title: $localize`Create/Edit`,
              link: '/drb/' + bundle_name + '/create',
              pathMatch: 'full'
            });
          }
          child.children.push({
            title: $localize`Deploy`,
            link: '/drb/' + bundle_name + '/deploy',
            pathMatch: 'full'
          });
        }
        this.menu[index].children.push(child);
      });
    }
  }
}
